import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  {
    name: "Marcus Reeves",
    role: "Owner, Reeves Trucking",
    quote:
      "Rocket Cap funded $85K in 26 hours. That truck is on the road today because of them. Zero bank runaround.",
    stars: 5,
    amount: "$85,000",
    product: "Equipment Financing",
  },
  {
    name: "Priya Shah",
    role: "Founder, Bloom Boutique",
    quote:
      "I was tired of getting denied by banks. Rocket Cap looked at my real revenue and approved me the same day.",
    stars: 5,
    amount: "$40,000",
    product: "Working Capital",
  },
  {
    name: "Daniel Wong",
    role: "CEO, Wong Restaurant Group",
    quote:
      "Three locations, three funding needs. Rocket Cap built a package that actually fit — not a cookie cutter.",
    stars: 5,
    amount: "$220,000",
    product: "Line of Credit",
  },
  {
    name: "Amber Lopez",
    role: "Contractor, AL Construction",
    quote:
      "The credit repair moved my score 130 points. Six months later I got a $150K SBA loan. Life changing.",
    stars: 5,
    amount: "$150,000",
    product: "Credit + SBA",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 md:py-32 bg-slate-50"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-14">
          <span className="text-xs font-bold uppercase tracking-[0.25em] text-purple-600">
            Testimonials
          </span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-black mt-3 tracking-tight text-slate-900">
            Real businesses. Real capital. Real growth.
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {testimonials.map((t, idx) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: idx * 0.08 }}
              data-testid={`testimonial-${idx}`}
              className="group relative rounded-3xl bg-white p-7 md:p-8 border border-slate-100 hover:border-purple-200 hover:shadow-2xl hover:shadow-purple-200/40 hover:-translate-y-1 transition-all"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-purple-100" />
              <div className="flex gap-1 mb-4">
                {Array.from({ length: t.stars }).map((_, i) => (
                  <Star key={i} className="w-4 h-4 fill-purple-500 text-purple-500" />
                ))}
              </div>
              <p className="text-lg text-slate-800 leading-relaxed font-medium">
                &ldquo;{t.quote}&rdquo;
              </p>
              <div className="mt-6 flex items-center justify-between border-t border-slate-100 pt-5">
                <div>
                  <p className="font-display font-bold text-slate-900">{t.name}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{t.role}</p>
                </div>
                <div className="text-right">
                  <p className="font-display text-lg font-black text-purple-700">
                    {t.amount}
                  </p>
                  <p className="text-[10px] uppercase tracking-widest text-slate-400 font-semibold">
                    {t.product}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
